export default __webpack_public_path__ + "static/media/Sidhu.a0e67d9f.jpg";